export default __webpack_public_path__ + "static/media/logo.0e6e4718.png";